import { subscribeOnAuthentification } from './subscribeOnAuthentification';
import { IRequestAuthenticationParameters } from './types';
import { IThunkActionCreator } from '../../types/thunk';

export function requestAuthentication(
  parameters?: IRequestAuthenticationParameters,
): IThunkActionCreator<Promise<void>> {
  return async (dispatch, getState, context) => {
    /* istanbul ignore else */
    if (typeof window !== 'undefined') {
      dispatch(subscribeOnAuthentification(parameters));

      /* istanbul ignore else */
      if (context.microfrontendsAPI) {
        await context.microfrontendsAPI.header.openAuthModal({
          autoRefresh: false,
        });
      }
    }
  };
}
